import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Magnify Minus Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-magnify-minus-outline',
    templateUrl: './icon-magnify-minus-outline.component.html',
    styleUrls: ['./icon-magnify-minus-outline.component.scss'],
    standalone: false
})
export class IconMagnifyMinusOutlineComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
